<template>
  <div :class=" `gb-zb-choice ${content.disabled === true ? 'gb-zb-disabled' : ''}` "
       v-on:click="handleChoice">
    {{ content.item.label }}
  </div>
</template>

<script>
import BaseMessage from '@/layout/messages/BaseMessage.vue'

export default {
  name: 'ContentChoice',
  extends: BaseMessage,
  methods: {
    handleChoice () {
      if (this.content.disabled === false) {
        if (this.content.kind === 'choice') {
          if (this.content.item.uuid !== null) {
            // should be choice
            const richContent = {
              kind: 'choosed',
              item: {
                uuid: this.content.item.uuid,
                label: this.content.item.label,
                desc: this.content.desc,
                img: this.content.icon
              }
            }
            this.$store.dispatch({
              type: 'sendMsg',
              content: this.content.item.label,
              richContent: richContent
            })
          } else {
            // this.sendMsg(this.content.uuid, this.content.content)
          }
        }
      }
      this.$store.commit(
        'disablePreviousChoices', this.content.item.uuid)
    }
  }
}

</script>

<style lang="scss" scoped>
div {
  font-weight: bold;
}
</style>
